import UrlBuilder from 'tools/urlBuilder';
import { SlaGridStoreArgs } from 'areas/sla/sla-grid/slaGridStore';

export function getDescriptions() {
	return [
		{
			url: '/sla',
			getModuleImport: () => import('./sla-grid/slaGridPage'),
			routeId: 'slas',
		},
		{
			jspUrl: 'include/Sla/SlaDetails.jsp',
			bodyCssClass: 'cw_sla_module',
			url: '/slas/:id',
			getModuleImport: () => import('./slaDetails'),
			routeId: 'slas_details',
		},
	];
}

export type SlaGridPageArgs = SlaGridStoreArgs & {};

export class SlaRouter {
	static list(options?: SlaGridPageArgs) {
		return new UrlBuilder('/sla').addObject(options).build();
	}

	static details(slaId: string) {
		return `/slas/${slaId}`;
	}

	static createNew() {
		return '/slas/new';
	}
}
